export default {
  dashboardMlsAgents: '/dashboard/mls-agents',
  dashboardMls: '/dashboard/mls',
};
